<template>
    <modal v-model="opened" :transition='0' :append-to-body="true" :backdrop="false"
           class="create-holidays-popup">
        <div slot="header">
            <a id="close_popup" @click="closePopup"></a>
            <h3 class="modal-title">{{header}}</h3>
        </div>
        <div class="row">
            <div class="col-sm-12">
                Are You sure you want to delete this Holiday?
            </div>
        </div>
        <div class="row margin-15-top" v-if="allowDeleteFromOtherGroups">
            <div class="col-sm-6">
                <vue-switch-with-label label="Delete from other Groups" :value="deleteFromAnotherGroups"
                                       @input="onDeleteFromAnotherGroupsChanged"
                                       name="addInAnotherGroups"></vue-switch-with-label>
            </div>
            <div class="col-sm-6" v-if="groupsToDeleteIdList.length" style="line-height: 31px">
                Holiday will be deleted from <strong>{{groupsToDeleteIdList.length}}</strong> Group<span
                    v-if="groupsToDeleteIdList.length>1">s</span>.
            </div>
        </div>
        <div slot="footer">
            <button class="btn btn-mm" @click="closePopup">Cancel</button>
            <button class="btn btn-mm btn-red" @click="del">
                Delete
            </button>
        </div>
    </modal>
</template>

<script>
    import Vue from 'vue';
    import _ from 'lodash';

    const DEFAULT_HEADER = 'Delete Holiday';
    export default {
        name: "GroupEventsPageHolidayDeletePopup",
        props: {
            groupId: Number,
        },
        data() {
            return {
                opened: false,
                header: DEFAULT_HEADER,
                allowDeleteFromOtherGroups: false,
                deleteFromAnotherGroups: false,
                groupsToDeleteIdList: [],
                allGroupsSelected: false,

                holidayId: undefined,
            };
        },
        methods: {
            show(holiday, allowDeleteFromOtherGroups, initial = {}) { // called outside
                this.holidayId = holiday.id;
                this.allowDeleteFromOtherGroups = allowDeleteFromOtherGroups;
                for (let f in initial) {
                    this[f] = initial[f];
                }
                this.opened = true;
                return new Promise((res, rej) => {
                    this.resolve = res;
                    this.reject = rej;
                });
            },
            showGroupsSelectorDeleteChanges() {
                const GroupEventsHolidaysResource = Vue.getAngularModule('GroupEventsHolidaysResource');
                const selectFactory = Vue.getAngularModule('selectFactory');
                this.opened = false;
                selectFactory.endpoint_selector(_.partial(GroupEventsHolidaysResource.get_groups_where_i_can_sync_holiday_changes, this.holidayId, this.groupId), true, {
                    header: `Delete Holiday from other Groups`,
                    info: `Select or de-select Groups where you are admin to delete this Holiday too.`,
                    button_yes: 'OK',
                    button_no: 'Cancel',
                    empty: `You do not have any Groups to select`,
                    select_all_html: 'Select all'
                }, false, true, false)
                    .then(
                        ([id_list, __, all]) => {
                            this.deleteFromAnotherGroups = true;
                            this.groupsToDeleteIdList = id_list;
                            this.allGroupsSelected = all;
                        },
                        cancel => {
                            this.groupsToDeleteIdList = [];
                            this.deleteFromAnotherGroups = false;
                        }
                    )
                    .finally(() => {
                        this.opened = true;
                    });
            },
            resetData() {
                this.header = DEFAULT_HEADER;
                this.allowDeleteFromOtherGroups = false;
                this.allGroupsSelected = false;
                this.deleteFromAnotherGroups = false;
                this.holidayId = undefined;
                this.groupsToDeleteIdList = [];
            },
            closePopup() {
                this.opened = false;
                this.reject('closed');
                this.resetData();
            },
            del() {
                this.opened = false;
                const res = {};
                if (this.deleteFromAnotherGroups && this.groupsToDeleteIdList && this.groupsToDeleteIdList.length) {
                    res.groupsToDeleteIdList = this.groupsToDeleteIdList;
                }
                if (this.deleteFromAnotherGroups && this.allGroupsSelected) {
                    res.all = true;
                }
                this.resolve(res);
                this.resetData();
            },
            onDeleteFromAnotherGroupsChanged(val) {
                if (val) {
                    this.showGroupsSelectorDeleteChanges();
                } else {
                    this.groupsToDeleteIdList = [];
                    this.deleteFromAnotherGroups = false;
                }
            }
        }
    };
</script>

<style scoped>

</style>